/**
 * Module dependencies.
 */

import { cn } from 'app/lib/utils';
import React from 'react';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  title: string;
  danger?: boolean;
  info?: string;
  large?: boolean;
  bold?: boolean;
  last?: boolean;
  value: string | JSX.Element;
};

/**
 * Export `Field` component.
 */

export function Field(props: Props): JSX.Element {
  const { className, last, info, title, bold, danger, large, value } = props;

  return (
    <div
      className={cn('w-full items-center py-2 border-b border-border', className, {
        'py-4 mb-4': !!info,
        'border-b-0': last
      })}
    >
      <div className={'flex justify-between'}>
        <div
          className={cn('text-primary', {
            'text-destructive': danger,
            'text-lg': large,
            'font-bold': bold
          })}
        >
          {title}
        </div>

        <div
          className={cn("font-['Oswald'] text-foreground", {
            'text-lg': large,
            'font-bold': bold
          })}
        >
          {value}
        </div>
      </div>

      {!!info && <div className={'mt-2 p-2 bg-[#eaeaea] rounded-2xl text-[#666] text-xs'}>{info}</div>}
    </div>
  );
}
